<template>
  <div>
    <div>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <div style="background-color: white; ">
          <p style="margin: 20px;" v-html="this.$store.state.ultimo_pedido_cliente_logado.pedido_html">
          </p>
        </div>
        <center>
        <div class="btn waves-effect waves-light cor-primaria-bg" style="padding: 0; width: 90%"
             @click="ChecarDisponibilidadeProdutosUltimoPedido()">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('repetir_pedido') }}
            </div>
          </div>
        </div>
        <div style="height:15px"></div>
        <div class="btn waves-effect waves-light cor-primaria-bg" style="padding: 0;width: 90%"
             @click="IrParaCarrinho()">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('voltar_para_nosso_cardapio') }}
            </div>
          </div>
        </div>
        </center>
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import axios from "axios";
import {
  IncluirNovoAdicionalDaCategoriaNoProduto,
  IncluirNovoAdicionalNoProduto,
  IncluirNovoProduto,
  ObterProdutoParaIncluirNoCarrinho
} from "../../../services/produto";

export default {
  name: "UltimoPedido",
  components: {LogoEmpresa, NavBarOnly, Loading},
  data() {
    return {
      isLoading: false,
      fullPage: true
    }
  },
  async mounted() {
    // Se a empresa desativou a funcionalidade, não permite acesso direto à página
    this.$watch(
      () => (this.$store && this.$store.state && this.$store.state.empresa)
        ? this.$store.state.empresa.desativar_acompanhar_ultimo_pedido
        : null,
      (flag) => {
        if (String(flag || "N").toUpperCase() === "S") {
          this.$router.replace("/" + this.$store.state.empresa_url + "/menu");
        }
      },
      { immediate: true }
    );

    $("body").css({"overflow": "unset"});
    window.scrollTo(0, 0);
    await this.ObterProdutosDaLoja();
  },
  methods: {
    async ObterProdutosDaLoja() {
      if (this.$store.state.grupos.length > 0 && this.$store.state.empresa_url == this.$route.params.empresa) {
        return;
      }
      this.isLoading = true;
      let response = await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url + '/grupos/produtos').catch(error => this.isLoading = false);
      this.$store.commit('grupos', response.data)
      this.isLoading = false;
    },
    IrParaCarrinho(){
      this.$router.push("/" + this.$store.state.empresa_url + "/pedido");
    },
    ChecarDisponibilidadeProdutosUltimoPedido() {
      const grupos = this.$store.state.grupos;
      const produtosLoja = [];
      grupos.forEach(grupo => {
        produtosLoja.push(...grupo.produtos);
      });

      const itens = this.$store.state.ultimo_pedido_cliente_logado.itens;
      this.LimparCarrinho();

      itens.forEach(produtoPedido => {
        const resultadoProdutoAtualizado = produtosLoja.find(p => p.id === produtoPedido.produto_id);
        
        if (resultadoProdutoAtualizado) {
          // Clone do produto para garantir que usamos as regras e preços ATUAIS da loja
          const produtoAtualizado = JSON.parse(JSON.stringify(resultadoProdutoAtualizado));
          const quantidadeProdutoOriginal = Math.max(1, produtoPedido.quantidade || 1);
          
          // Inicializa o estado das categorias e adicionais (zera quantidades para o novo cálculo)
          produtoAtualizado.categorias.forEach((c) => {
            c.quantidade = 0;
            c.maiorValor = 0;
            c.adicionais.forEach((a) => {
              a.quantidade = 0;
            });
          });
          if (produtoAtualizado.adicionais) {
            produtoAtualizado.adicionais.forEach((a) => {
              a.quantidade = 0;
            });
          }

          // Prepara o serviço de produto com o item base e preço atual
          IncluirNovoProduto(
            produtoAtualizado.id,
            produtoAtualizado.promocao === 'S' ? produtoAtualizado.valor_promocional : produtoAtualizado.valor,
            produtoAtualizado.somente_retirada,
            produtoAtualizado.nome,
            produtoPedido.observacao_cliente,
            produtoPedido.quantidade,
            produtoAtualizado.permite_cupom_desconto || 'S'
          );

          let impedimentoProduto = false;

          if (produtoPedido.adicionais && produtoPedido.adicionais.length > 0) {
            for (const adPedido of produtoPedido.adicionais) {
              if (impedimentoProduto) break;

              let localizado = false;
              
              // Busca o adicional nas categorias atuais
              for (const categoria of produtoAtualizado.categorias) {
                const adApi = categoria.adicionais.find(a => a.adicional_id === adPedido.adicional_id);
                if (adApi) {
                  localizado = true;
                  
                  // Divide a quantidade total de adicionais pela quantidade do item principal (por unidade)
                  let qtdParaAdicionar = adPedido.adicional_quantidade / quantidadeProdutoOriginal;
                  
                  let fator = adApi.fator_acrescimo ? parseFloat(adApi.fator_acrescimo) : 1;
                  if (adApi.usa_fator_acrescimo !== "S") fator = 1;

                  // Tenta adicionar a quantidade do pedido antigo, validando rigorosamente os NOVOS limites
                  while (qtdParaAdicionar >= (fator - 0.001)) {
                    // Verifica se o limite da CATEGORIA foi atingido (unitário)
                    if (categoria.limitar === "S" && (categoria.quantidade + fator) > (categoria.maximo + 0.001)) {
                      impedimentoProduto = true;
                      break;
                    }
                    // Verifica se o limite deste ADICIONAL específico foi atingido (unitário)
                    if (adApi.limitar === "S" && (adApi.quantidade + fator) > (adApi.maximo + 0.001)) {
                      impedimentoProduto = true;
                      break;
                    }

                    IncluirNovoAdicionalDaCategoriaNoProduto(categoria, adApi, this.$store.state.empresa.pizza_maior_preco);
                    qtdParaAdicionar -= fator;
                  }
                  break;
                }
              }

              // Se não estiver em categorias, busca nos adicionais gerais
              if (!localizado && !impedimentoProduto && produtoAtualizado.adicionais) {
                const adApi = produtoAtualizado.adicionais.find(a => a.adicional_id === adPedido.adicional_id);
                if (adApi) {
                  localizado = true;
                  IncluirNovoAdicionalNoProduto(adApi);
                }
              }

              // Se o adicional do pedido original não foi localizado na API atual ou houve estouro de limite
              if (!localizado || impedimentoProduto) {
                impedimentoProduto = true;
                break;
              }
            }
          }

          // Validação final: o produto ajustado ainda cumpre os mínimos obrigatórios?
          if (!impedimentoProduto) {
            const faltamObrigatorios = produtoAtualizado.categorias.some(cat => 
              cat.obrigatorio === 'S' && cat.quantidade < cat.minimo
            );
            if (faltamObrigatorios) {
              impedimentoProduto = true;
            }
          }

          if (impedimentoProduto) {
            M.toast({ html: this.$t('produto_sofreu_alteracoes') + produtoPedido.produto_nome, displayLength: 5000 });
          } else {
            this.EnviarProdutoParaCarrinho(ObterProdutoParaIncluirNoCarrinho());
          }
        } else {
          M.toast({ html: this.$t('produto_indisponivel') + (produtoPedido.produto_nome || "ID " + produtoPedido.produto_id), displayLength: 3000 });
        }
      });
    },
    LimparCarrinho(){
      this.$store.commit("pedido",{
        itens: []
      });
    },
    EnviarProdutoParaCarrinho(produto){
      this.$store.commit("adicionar_item_pedido", produto);
      this.IrParaCarrinho();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/UltimoPedido.vue